<template v-if="authenticated">
  <div class="p-5 mon-compte">
    <breadcrumbs></breadcrumbs>

    <div class="page_title">
      <h1>Mon compte</h1>
    </div>
    <div class="flex md:flex-row flex-col md:items-start">
      <div class="md:w-1/3 md:h-96">
        <div class="rounded bg-grisclair px-12 py-12 mb-8 md:h-60">
          <h1 class="bold mb-20">Paramètres du compte</h1>
          <p class="mb-1 mt-7">{{ username }}</p>
          <p class="mail-compte">{{ mail }}</p>
        </div>
        <div class="rounded bg-grisclair px-12 py-12 mb-8 md:h-60">
          <h1 class="bold underline">
            <router-link :to="{ name: 'forgot' }">
              Modifier mon mot de passe
            </router-link>
          </h1>
          <p class="mt-7">
            Pour changer les autres détails de votre compte :
            <a
              href="https://acta-editions.com/"
              class="underline"
              target="_blank"
              >connectez-vous sur acta-editions.fr</a
            >
          </p>
        </div>
      </div>
      <div
        class="
          rounded
          bg-grisclair
          mb-8
          border border-orange
          md:ml-8 md:w-1/3 md:h-98
          flex flex-col
          justify-center
        "
      >
        <h1 class="bold pt-5 px-9">Mon abonnement</h1>
        <div v-if="hasActiveSubscription" class="pb-5 px-9">
          <p class="orange mb-4">Formule {{ subscription_product_name }}</p>
          <div class="mb-4">
            <p>Date de la commande</p>
            <p>{{ format_date(subscription_start_date) }}</p>
          </div>
          <div class="mb-4">
            <p>Fin de l'abonnement</p>
            <p>{{ format_date(subscription_end_date) }}</p>
          </div>
        </div>
        <div v-else class="flex flex-col px-9 py-2">
          <form
            @submit.prevent="activeSubForm"
            class="mt-2"
            v-if="!activeSubValidate && !hasActiveSubscription"
          >
            <div>
              <input
                type="checkbox"
                name="activeSub"
                id="activeSub"
                v-model="trialOffer"
              />
              <label for="activeSub" class="leading-3"
                >Je souhaite activer l’offre découverte et bénéficier d'un mois
                d’essai offert pour naviguer sur le site Index Acta.</label
              >
            </div>
            <button class="bg-orange px-5 py-2 mt-6 text-white">Valider</button>
          </form>
          <div v-else>
            <div v-if="activeSubValidate">Abonnement Activé !</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Breadcrumbs from "@/components/Breadcrumbs";
import User from "@/api/users.js";
import Authent from "@/api/authent.js";
import { mapState } from "vuex";
import moment from "moment";

export default {
  name: "ProfileAccount",
  components: {
    Breadcrumbs,
    User,
    Authent,
  },

  data() {
    return {
      activeSubValidate: false,
      trialOffer: "",
    };
  },
  async mounted() {
    await this.$store.dispatch("authent/updateUser", {});
  },

  computed: {
    ...mapState("authent", {
      username: (state) => state.user.full_name,
      mail: (state) => state.user.email,
      subscription_end_date: (state) => state.user.subscription.end_date,
      subscription_start_date: (state) => state.user.subscription.start_date,
      subscription_product_name: (state) =>
        state.user.subscription.product_name,
    }),

    authenticated() {
      return this.$store.getters["authent/isAuthenticated"];
    },
    hasActiveSubscription() {
      return this.$store.getters["authent/hasActiveSubscription"];
    },
    hadActiveSubscription() {
      return this.$store.getters["authent/hadActiveSubscription"];
    },

    substractDate() {
      let limitDate = moment(this.subscription_end_date).subtract(7, "days");
      if (moment().isAfter(limitDate)) {
        return true;
      }
    },
  },

  methods: {
    format_date(date) {
      moment().locale("fr");
      return moment(date).format("DD/MM/YYYY");
    },

    async activeSubForm() {
      await User.trialOffer(this.trialOffer);
      await this.$store.dispatch("authent/updateUser", {});
    },
  },
};
</script>

<style>
</style>